export default __webpack_public_path__ + "static/home-74cb26ffe9b48310897849ee8a90e10b.png";